import React from 'react';
import { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useUnreadCount } from '../components/UnreadCountContext';

type Props = { 
	user: any,
	handleLogout(): void 
};

const LogoutPage: React.FC<Props> = (props) => {
	const { setNotificationUnread } = useUnreadCount();

	useEffect(() => {
    return () => {
      // do nothing
    };
	}, []);	

	if (props.user.isLogged) {
		setNotificationUnread(0);
		localStorage.removeItem('selectedDistance');
		props.handleLogout();
	}
	return ( <Redirect to="/home"/> )
}

export default LogoutPage;